var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoItems = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 92,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M86.6 6.586 5.804 88.342"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M81.486 21.357C86.23 28.463 89 37.03 89 46.25c0 24.59-19.7 44.524-44 44.524a43.42 43.42 0 0 1-23.998-7.2m-6-4.752C6.387 70.694 1 59.109 1 46.25 1 21.66 20.7 1.726 45 1.726c12.626 0 24.01 5.382 32.035 14.002"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M55.5 38.058H34.44v20.84M56.264 41.62V58.7a5 5 0 0 1-5.004 5l-14.356-.012"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M56.968 44.469h5.28c3.5 0 6.336-2.87 6.336-6.411a6.44 6.44 0 0 0-2.832-5.343M33.736 44.469h-5.28c-3.5 0-6.336-2.87-6.336-6.411s2.837-6.412 6.336-6.412H61.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m46.76 57.292 2.816 2.85 2.816-2.85M49.576 53.018v7.123"
})));
export default SvgNoItems;